/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type { ListTagsParams, PraetoidError, TagFeedResponse } from '../models';

/**
 * Returns all tags available for the organization (builtin + custom)
 * @summary List tags
 */
export const listTags = (params?: ListTagsParams) => {
	return customInstance<TagFeedResponse>({ url: `/tags`, method: 'GET', params });
};

export const getListTagsQueryKey = (params?: ListTagsParams) => {
	return ['tags', ...(params ? [params] : [])] as const;
};

export const getListTagsQueryOptions = <
	TData = Awaited<ReturnType<typeof listTags>>,
	TError = ErrorType<PraetoidError>
>(
	params?: ListTagsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListTagsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listTags>>> = () => listTags(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listTags>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTagsQueryResult = NonNullable<Awaited<ReturnType<typeof listTags>>>;
export type ListTagsQueryError = ErrorType<PraetoidError>;

export function useListTags<
	TData = Awaited<ReturnType<typeof listTags>>,
	TError = ErrorType<PraetoidError>
>(
	params: undefined | ListTagsParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listTags>>,
					TError,
					Awaited<ReturnType<typeof listTags>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTags<
	TData = Awaited<ReturnType<typeof listTags>>,
	TError = ErrorType<PraetoidError>
>(
	params?: ListTagsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listTags>>,
					TError,
					Awaited<ReturnType<typeof listTags>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTags<
	TData = Awaited<ReturnType<typeof listTags>>,
	TError = ErrorType<PraetoidError>
>(
	params?: ListTagsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List tags
 */

export function useListTags<
	TData = Awaited<ReturnType<typeof listTags>>,
	TError = ErrorType<PraetoidError>
>(
	params?: ListTagsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListTagsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}
